(function () {
  'use strict';
  function initDavlQuoteBuilder() {
    var builder = document.getElementById('DavlQuoteBuilder');
    if (!builder || !document.documentElement.classList.contains('davl-quick-quote-mode')) return;
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var lines = builder.querySelector('[data-davl-quote-lines]');
    var add = builder.querySelector('[data-davl-quote-add]');
    var error = builder.querySelector('[data-davl-quote-error]');
    var notes = document.getElementById('DavlQuoteNotes');
    var params = new URLSearchParams(window.location.search);
    var counter = 0;
    var searchBase = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
      if (message) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function updateRemoveButtons() {
      var buttons = lines.querySelectorAll('[data-davl-remove]');
      buttons.forEach(function (button) { button.disabled = buttons.length === 1; });
    }
    function describe(item) {
      return (item.sku ? item.sku + ' — ' : '') + (item.title || '');
    }
    function addLine(item) {
      item = item || {};
      counter += 1;
      var number = counter;
      var row = document.createElement('div');
      row.className = 'davl-quote-builder__row';
      row.innerHTML =
        '<div class="davl-quote-builder__field davl-quote-builder__field--product">' +
          '<label class="davl-quote-builder__label" for="DavlProduct' + number + '">Product (SKU — Description)</label>' +
          '<input id="DavlProduct' + number + '" class="davl-quote-builder__search" type="search" autocomplete="off" role="combobox" aria-autocomplete="list" aria-haspopup="listbox" aria-expanded="false" aria-controls="DavlResults' + number + '" placeholder="Search SKU or description" />' +
          '<ul id="DavlResults' + number + '" class="davl-quote-builder__dropdown" role="listbox" hidden></ul>' +
        '</div>' +
        '<div class="davl-quote-builder__field davl-quote-builder__field--qty">' +
          '<label class="davl-quote-builder__label" for="DavlQuantity' + number + '">Qty</label>' +
          '<input id="DavlQuantity' + number + '" class="davl-quote-builder__qty" type="number" min="1" step="1" inputmode="numeric" value="1" required />' +
        '</div>' +
        '<button type="button" class="davl-quote-builder__remove" data-davl-remove aria-label="Remove this product">Remove</button>';
      var search = row.querySelector('.davl-quote-builder__search');
      var results = row.querySelector('.davl-quote-builder__dropdown');
      var qty = row.querySelector('.davl-quote-builder__qty');
      var debounce;
      var request;
      var sequence = 0;
      function hideResults() {
        results.hidden = true;
        search.setAttribute('aria-expanded', 'false');
      }
      function status(message) {
        results.replaceChildren();
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        li.className = 'davl-quote-builder__option';
        li.textContent = message;
        results.appendChild(li);
        results.hidden = false;
        search.setAttribute('aria-expanded', 'true');
      }
      function choose(choice) {
        row.dataset.sku = choice.sku || '';
        row.dataset.title = choice.title || '';
        row.dataset.handle = choice.handle || '';
        row.dataset.bstock = choice.bstock ? 'true' : 'false';
        search.value = describe(choice);
        hideResults();
        showError('');
      }
      if (item.title || item.sku) choose(item);
      qty.value = String(item.qty && Number(item.qty) > 0 ? item.qty : 1);
      async function findMatches(query) {
        sequence += 1;
        var thisSearch = sequence;
        if (request) request.abort();
        request = new AbortController();
        status('Searching products…');
        try {
          var url = searchBase + 'search/suggest?q=' + encodeURIComponent(query) +
            '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bunavailable_products%5D=show&section_id=davl-quote-suggest';
          var response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search request failed');
          var markup = await response.text();
          if (thisSearch !== sequence || !row.isConnected || document.activeElement !== search) return;
          var fragment = new DOMParser().parseFromString(markup, 'text/html');
          var options = fragment.querySelectorAll('[data-davl-results] [data-davl-sku]');
          if (!options.length) { status('No matching products. Try another SKU or description.'); return; }
          results.replaceChildren();
          options.forEach(function (option) {
            var li = document.createElement('li');
            li.setAttribute('role', 'presentation');
            var button = option.cloneNode(true);
            button.addEventListener('mousedown', function (event) { event.preventDefault(); });
            button.addEventListener('click', function () {
              choose({
                sku: option.getAttribute('data-davl-sku'),
                title: option.getAttribute('data-davl-title'),
                handle: option.getAttribute('data-davl-handle'),
                bstock: option.getAttribute('data-davl-bstock') === 'true'
              });
            });
            li.appendChild(button);
            results.appendChild(li);
          });
          results.hidden = false;
          search.setAttribute('aria-expanded', 'true');
        } catch (ex) {
          if (ex.name !== 'AbortError' && thisSearch === sequence) status('Search is unavailable. Please retry.');
        }
      }
      search.addEventListener('focus', function () {
        if (!row.dataset.title) {
          if (search.value.trim().length >= 2) findMatches(search.value.trim());
          else status('Type at least 2 characters to search products.');
        }
      });
      search.addEventListener('input', function () {
        row.dataset.title = '';
        row.dataset.sku = '';
        row.dataset.handle = '';
        row.dataset.bstock = '';
        clearTimeout(debounce);
        sequence += 1;
        if (request) request.abort();
        var value = search.value.trim();
        if (value.length < 2) { status('Type at least 2 characters to search products.'); return; }
        debounce = setTimeout(function () { findMatches(value); }, 220);
      });
      search.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') hideResults();
        if (event.key === 'ArrowDown' && !results.hidden) {
          var first = results.querySelector('button');
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
      results.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { hideResults(); search.focus(); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          var buttons = Array.from(results.querySelectorAll('button'));
          var i = buttons.indexOf(document.activeElement);
          var next = buttons[i + (event.key === 'ArrowDown' ? 1 : -1)];
          if (next) { event.preventDefault(); next.focus(); }
        }
      });
      document.addEventListener('click', function (event) {
        if (!row.contains(event.target)) hideResults();
      });
      row.querySelector('[data-davl-remove]').addEventListener('click', function () {
        if (lines.children.length <= 1) return;
        if (request) request.abort();
        clearTimeout(debounce);
        row.remove();
        updateRemoveButtons();
        showError('');
      });
      lines.appendChild(row);
      updateRemoveButtons();
      return row;
    }

    var cartItems = params.get('cart');
    if (cartItems) {
      var parts = cartItems.split(/\\n|\n/).map(function (x) { return x.trim(); }).filter(Boolean);
      parts.forEach(function (line) {
        var m = line.match(/^(\d+)\s*x\s*(.*?)(?:\s+\(SKU:\s*(.*?)\))?$/i);
        if (m) addLine({ qty: Number(m[1]), title: m[2].trim(), sku: (m[3] || '').trim(), bstock: /b[\s-]?stock/i.test(line) });
      });
    } else if (params.get('product') || params.get('sku')) {
      addLine({
        title: params.get('product') || '',
        sku: params.get('sku') || '',
        handle: params.get('handle') || '',
        qty: 1,
        bstock: params.get('b_stock') === 'true'
      });
    }
    if (!lines.children.length) addLine();
    add.addEventListener('click', function () {
      var row = addLine();
      row.querySelector('.davl-quote-builder__search').focus();
    });

    form.addEventListener('submit', function (event) {
      var rows = Array.from(lines.querySelectorAll('.davl-quote-builder__row'));
      var order = [];
      for (var i = 0; i < rows.length; i += 1) {
        var row = rows[i];
        var quantity = Number(row.querySelector('.davl-quote-builder__qty').value);
        if (!row.dataset.title) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError('Select a product from the dropdown for item ' + (i + 1) + '.');
          row.querySelector('.davl-quote-builder__search').focus();
          return;
        }
        if (!Number.isSafeInteger(quantity) || quantity < 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError('Enter a whole-number quantity of at least 1 for item ' + (i + 1) + '.');
          row.querySelector('.davl-quote-builder__qty').focus();
          return;
        }
        order.push({
          sku: row.dataset.sku || 'SKU not listed',
          title: row.dataset.title,
          quantity: quantity,
          bstock: row.dataset.bstock === 'true'
        });
      }
      showError('');
      var hasBstock = order.some(function (item) { return item.bstock; });
      var requestType = document.getElementById('ContactForm-request-type');
      var bodyField = document.getElementById('ContactForm-body');
      var emailField = document.getElementById('ContactForm-email');
      var nameField = document.getElementById('ContactForm-name');
      if (requestType) requestType.value = hasBstock ? 'B-Stock Availability' : 'Quote Request';

      // Keep one readable product-and-quantity list in the native Shopify
      // contact message; never send duplicate product/quantity custom fields.
      if (bodyField) {
        var messageLines = [
          'QUOTE REQUEST - ' + order.length + (order.length === 1 ? ' PRODUCT' : ' PRODUCTS'),
          '',
          'PRODUCTS AND QUANTITIES',
          ''
        ];
        order.forEach(function (item, index) {
          messageLines.push(
            (index + 1) + '. QUANTITY: ' + item.quantity,
            '   SKU: ' + item.sku,
            '   PRODUCT: ' + item.title
          );
          if (item.bstock) messageLines.push('   B-STOCK: Please confirm availability and condition');
          messageLines.push('');
        });
        if (notes && notes.value.trim()) {
          messageLines.push('CUSTOMER NOTES', notes.value.trim(), '');
        }
        bodyField.value = messageLines.join('\n').trim();
      }

      // Shopify emails all named contact fields, including blanks and hidden
      // campaign identifiers. Exclude them only for the quick-quote builder.
      // Preserve email and message, plus the name if the customer supplied it.
      // Keep non-contact form fields (including Shopify anti-spam tokens) intact.
      Array.from(form.querySelectorAll('[name^="contact["]')).forEach(function (input) {
        var isCustomerName = input === nameField && input.value.trim() !== '';
        input.disabled = !(input === emailField || input === bodyField || isCustomerName);
      });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDavlQuoteBuilder);
  else initDavlQuoteBuilder();
}());